{
  "enum": {
    "IxcAssetsClearingV1MoneyMarketInternalStatsStatus": {
      "COMPLETED": "Completed",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListFilterableFields": {
      "assetId": "Asset",
      "dataHash": "Data Hash",
      "date": "Date",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcAssetsClearingV1MoneyMarketInternalStatsEventType": {
      "upserted": "Upserted"
    }
  },
  "sortEnum": {
    "IxcAssetsClearingV1MoneyMarketInternalStatsQueryServiceMoneyMarketInternalStatsListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}